/** The Atelier mark: an ink tile with a clay chevron — a roof, a rising line,
 *  the "A". Used in the header, the sign-in page and the favicon, so it lives
 *  in one place rather than being re-drawn per surface. */
export default function Mark({ className = "h-6 w-6" }: { className?: string }) {
  return (
    <svg viewBox="0 0 32 32" className={className} aria-hidden="true">
      <rect width="32" height="32" rx="7" className="fill-ink" />
      <path
        d="M9 22 16 10l7 12"
        className="stroke-clay"
        strokeWidth="2.5"
        fill="none"
        strokeLinejoin="round"
        strokeLinecap="round"
      />
    </svg>
  );
}
